export default __webpack_public_path__ + "static/download-ios-acc8b28b22c537c4a52e521bcaf80099.svg";